import React, { useState, useEffect } from 'react';
import { Modal, Button, Tree } from 'antd';
import type { TreeProps } from 'antd';

interface RuleUsersModalProps {
  isEditable: boolean;
  users: any[] | undefined;
  onSave: (users: string[], userCount: number| undefined) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  userTree: any[];
  usersCount: number;
}

const SpecialsUsersModal: React.FC<RuleUsersModalProps> = ({ isEditable, isOpen, setIsOpen, users, onSave, userTree, usersCount }) => {
  const [selectedUsers, setSelectedUsers] = useState<string[] | undefined>(users);
  const [currentUsersCount, setCurrentUsersCount] = useState<number| undefined>(usersCount);
  useEffect(() => {
    setSelectedUsers(users);
    setCurrentUsersCount(usersCount)
  }, [users])
  const save = async () => {
    onSave(selectedUsers ?? [], currentUsersCount);
    setIsOpen(false);
  };

  const onUserCheck: TreeProps['onCheck'] = (checkedKeys) => {
    const keys = (checkedKeys as string[]);
    setCurrentUsersCount(keys?.filter(key => key.startsWith('user-'))?.length);
    setSelectedUsers(keys);
  };

  return (
    <Modal
      width={700}
      title='Выбор участников'
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={isEditable ? [
        <Button key="submit" type="primary" onClick={save}>
          Сохранить
        </Button>,
      ] : []}
    >
      <div style={{ marginBottom: 15 }}>
        <span style={{ float: 'right' }}>Участники: {currentUsersCount}</span>
      </div>
      <Tree
        checkable
        checkedKeys={selectedUsers}
        defaultExpandedKeys={["all"]}
        treeData={userTree}
        onCheck={onUserCheck}
      />
    </Modal>
  );
};

export default SpecialsUsersModal;